export const HOME_PAGE_ROUTE = '/';
export const LOG_PAGE_ROUTE = '/logs';
export const MANAGE_PAGE_ROUTE = '/manage';
export const NOTIFY_PAGE_ROUTE = '/notify';
export const REPORT_PAGE_ROUTE = '/report';
